import Vue from 'vue';
import { weekdaysShort, months } from 'moment';

import {
  ConfigProgrammatic,
  Progress,
  Dialog,
  Modal,
  Icon,
  Datepicker,
  Datetimepicker,
  Field,
  Input,
  Autocomplete,
  Select,
  Button,
  Radio,
  Table,
  Checkbox,
  Upload,
  Dropdown,
  Notification,
  Loading,
} from 'buefy';

Vue.use(Progress);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Modal);
Vue.use(Datepicker);
Vue.use(Datetimepicker);
Vue.use(Field);
Vue.use(Input);
Vue.use(Select);
Vue.use(Radio);
Vue.use(Autocomplete);
Vue.use(Button);
Vue.use(Table);
Vue.use(Checkbox);
Vue.use(Upload);
Vue.use(Dropdown);
Vue.use(Notification);
Vue.use(Loading);

ConfigProgrammatic.setOptions({
  defaultDayNames: weekdaysShort().map(
    (el) => `${el[0].toUpperCase()}${el.slice(1)}`
  ),
  defaultMonthNames: months().map(
    (el) => `${el[0].toUpperCase()}${el.slice(1)}`
  ),
});
